import styled, { css } from "styled-components";

export const Container = styled.div`
    width: 100%;
    max-width: 600px;
    padding: 3rem 0.5rem 3rem 0.5rem;
    margin: 0.5rem auto;
    border-radius: 10px;
    background: #F0F1F5;
    color: #535354;
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;


    .buttonsConfig{
        position: absolute;
        top: 10px;
        right: 10px;

        display: flex;
        align-items: center;

        svg{
            font-size: 1.7rem;
            margin: 0 0.2rem;    
            &:first-child{
                font-size: 1.6rem;
            }
            &:hover{
                cursor: pointer;
            }
        }
    }


    .image{
        height: 3.5rem;
        width: 10rem;

        background-image: url("${props => props.src}");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }

    .info{
        font-size: 0.9rem;
        margin-left: 0.2rem;
        font-weight: 900;

        div{
            display: flex;
            align-items: center;
            margin-top: 0.2rem;
            font-size: 0.8rem;

            svg{
                font-size: 1.1rem;
                margin-right: 0.2rem;
            }
        }
    }
`

export const Slider = styled.div`
    height: 1.5rem;
    width: 2.5rem;
    background: ${props => props.switchButtonActive ? 'green' : '#535354'};
    border-radius: 15px;
    margin-left: 0.5rem;
    transition: background 0.3s ease;

    display: flex;
    align-items: center;

    .circle{
        height: 1.1rem;
        width: 1.1rem;
        background: #FFF;
        border-radius: 50%;
        transition: transform 0.3s ease;
        transform: translateX(20%);
    }

    &:hover{
        cursor: pointer;
    }

    ${props => props.switchButtonActive && css`
        .circle{
            transform: translateX(110%);
        }
    `}
`